'use client';

import PublishIcon from '@mui/icons-material/Publish';
import { Box, ButtonBase, Tooltip, type SxProps } from '@mui/material';
import { useObservable } from '@ocodelib/mui/hooks';
import { flatSx, FlexColumn } from '@ocodelib/mui';
import { Allotment } from 'allotment';
import { IframeMonacoEditorWrapper } from '../../iframes/IframeMonacoEditorWrapper';
import { useP5BasicApp } from '../../useP5BasicApp';
import { CodeEditorTop } from './CodeEditorTop';
import { LogContainer } from './LogContainer';

interface Props {
  sx?: SxProps;
}

export function CodeEditorContainer(props: Props) {
  const { sx } = props;
  const { app, appManager } = useP5BasicApp();
  const logVisible = useObservable(app?.logVisible$) ?? false;
  const datiBaseURL = appManager.appConfig.datiBaseURL;

  // Allotment에서 드래그가 끝났을 때
  // 로그창을 아래로 드래그 하면 감춘다
  const onDragEnd = (sizes: number[]) => {
    if (sizes.length !== 2) return;
    if (sizes[1]! <= 60) {
      app?.setLogVisible(false);
    }
  };

  return (
    <FlexColumn
      alignItems="stretch"
      className="CodeEditorContainer-root"
      sx={flatSx(
        {
          position: 'relative',
          width: '100%',
          height: '100%',
        },
        sx,
      )}
    >
      <CodeEditorTop />
      <Box
        component={Allotment}
        vertical
        sx={{
          flex: 1,
          '& .CodeEditorContainer-editor': {
            width: '100%',
            height: '100%',
          },
        }}
        onDragEnd={onDragEnd}
      >
        <Allotment.Pane minSize={40}>
          <IframeMonacoEditorWrapper
            className="CodeEditorContainer-editor"
            datiBaseURL={datiBaseURL}
            onLoadEditor={(editor) => {
              app.setupCodeEditor(editor);
            }}
          />
        </Allotment.Pane>
        {logVisible && (
          <Allotment.Pane minSize={40}>
            <LogContainer sx={{ height: '100%' }} />
          </Allotment.Pane>
        )}
      </Box>

      {/* log fab button */}
      {!logVisible && (
        <Tooltip title="show console log">
          <ButtonBase
            onClick={() => {
              app?.setLogVisible((p) => !p);
            }}
            sx={{
              position: 'absolute',
              width: 32,
              height: 32,
              bottom: 20,
              right: 20,
              bgcolor: 'rgba(255,255,255,0.7)',
              boxShadow: 1,
              borderRadius: '50%',
            }}
          >
            <PublishIcon />
          </ButtonBase>
        </Tooltip>
      )}
    </FlexColumn>
  );
}
